import { NavLink, useNavigate } from "react-router-dom";
import "../../assets/styles/sliderBar.css";

function AdminSidebar({ open, setOpen }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <div className={open ? "admin-sidebar active" : "admin-sidebar"}>
      
      <h2 className="logo">Shuttle Craft</h2>

      <ul onClick={() => setOpen(false)}>
        <li>
          <NavLink to="/dashboard">Dashboard</NavLink>
        </li>

        <li>
          <NavLink to="/students">Students</NavLink>
        </li>

        <li>
          <NavLink to="/attendance">Attendance</NavLink>
        </li>

        <li>
          <NavLink to="/payments">Payments</NavLink>
        </li>

        <li onClick={handleLogout}>Logout</li>
      </ul>
    </div>
  );
}

export default AdminSidebar;